angular.module('service-request.handover', ['core'])
    .component('serviceRequestPropertyHandover', {
        bindings: {
        },
        templateUrl: 'app/service-request/handover/index.html',
        controller: function ($scope, $state, $stateParams, $http, PropertyDealService) {
            this.PropertyDealService = PropertyDealService
            this.$onInit = () => {
                this.item = {
                }
            }

            this.search = () => {
                let params = {
                    client: this.item.client?.id,
                    project: this.item.project?.id,
                    property: this.item.property,
                    showAll: this.item.showAll,
                    reportedDefects: this.item.reportedDefects,
                }
                delete this.propertyDeals
                delete this.tableStatistics
                return $http.get("/crm/api/service-request-property-handover/search", { params: params}).then(response => {
                    this.propertyDeals = response.data
                    this.tableStatistics = {
                        count: this.propertyDeals.length,
                        processed: this.propertyDeals.filter(i => i.transfer != null).length,
                        unprocessed: this.propertyDeals.filter(i => i.transfer == null).length
                    }
                })
            }

            this.canBeTransferred = (status, transfer) => {
                let acceptableStatuses = ['SOLD', 'FINISHED'];
                return transfer == null && acceptableStatuses.includes(status);
            }

            // $scope.$on('property-deal.updated', () => $state.reload());
            this.onClientSelected = (value) => {
                if (value) {
                    this.item.client = value
                } else {
                    delete this.item.client
                }
            }
        }
    })
    .config(function ($stateProvider) {
        $stateProvider.state('serviceRequestPropertyHandover', {
            parent: 'app',
            url: '/service-request-property-handover',
            data: {
                authorities: ['ROLE_SERVICE_REQUEST']
            },
            views: {
                'content@': 'serviceRequestPropertyHandover'
            },
            resolve: {
            }
        });
    });
